module.exports = __webpack_public_path__ + "static/img/ninja2.c07ece5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ninja2.jpg
// module id = bMfH
// module chunks = 0